import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1351d755"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "checkout-buy-with-eth" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "checkout-buyer-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkout-buyer-title" }, "Buying as", -1))
const _hoisted_6 = ["data-network", "data-fallback-provider"]
const _hoisted_7 = {
  key: 1,
  class: "checkout-error-message"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://docs.manifold.xyz/v/manifold-studio/integrations/delegate-cash" }, "Learn more.", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { class: "checkout-tx-hash-container" }
const _hoisted_19 = ["data-network", "data-address"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkout-refund-message" }, " All costs will be refunded if the outcome is not delivered within 7 days after the mint period ends. ", -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { key: 5 }
const _hoisted_27 = { key: 6 }
const _hoisted_28 = { key: 7 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["data-network", "data-fallback-provider"]

import { computed, onMounted, ref } from 'vue';
import { Network } from '@manifoldxyz/js-ts-utils';
import CheckoutSuccessPage from '@/components/checkout/CheckoutSuccessPage.vue';
import PayWithCardButton from '@/components/checkout/PayWithCardButton.vue';
import TransactionDetails from '@/components/checkout/TransactionDetails.vue';
import DelegationPicker from '@/components/DelegationPicker.vue';
import CheckoutItemsForPledge from '@/components/pledge/CheckoutItemsForPledge.vue';
import PurchaseInputForPledge from '@/components/pledge/PurchaseInputForPledge.vue';
import SpecialNetworkBanner from '@/components/SpecialNetworkBanner.vue';
import Spinner from '@/components/Spinner.vue';
import { useCollect } from '@/composables/collect';
import { useConfetti } from '@/composables/confetti';
import { useMint } from '@/composables/mint';
import { abbreviateAddress, pluralize, transformError } from '@/lib/claimUtil';
import { NETWORK_CONFIGS } from '@/lib/networks';
import * as telemetry from '@/lib/telemetry';
import { SignatureSchema, useClaimStore } from '@/store/claimStore';

interface BuyWithEthPageProps {
  goToPayWithCard: () => void;
  onSuccess?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyWithEthPageForPledge',
  props: {
    goToPayWithCard: { type: Function },
    onSuccess: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const store = useClaimStore();
const { addConfetti } = useConfetti();

const showConnectWidget = ref(false);
const purchaseSucceded = ref(false);
const purchaseError = ref('');

const {
  mint,
  tx,
  isError: isMintingError,
  error: mintingError,
  isLoading: isMinting,
} = useMint({
  onSuccess: () => {
    addConfetti();

    purchaseSucceded.value = true;

    telemetry.paymentSuccess(
      'eth',
      store.tokensToPurchase,
      'same-wallet',
      // This is 'ETH' in the default case
      store.erc20Symbol.toLowerCase()
    );

    if (props.onSuccess) {
      props.onSuccess();
    }
  },
  onError: (error: any) => {
    purchaseError.value = 'Error minting';
    telemetry.paymentError(
      'eth',
      store.tokensToPurchase,
      'same-wallet',
      transformError(error)?.error
    );
  },
});

const {
  collect,
  tx: collectTx,
  isLoading: isCollectingLoading,
  isError: isCollectingError,
  error: collectingError,
} = useCollect({
  onSuccess: () => {
    addConfetti();

    purchaseSucceded.value = true;

    telemetry.collectSuccess(
      'eth',
      store.tokensToPurchase,
      store.mintForWallet ? 'different-wallet' : 'custodial-wallet'
    );
  },
  onError: (error: any) => {
    purchaseError.value = 'Error collecting';
    telemetry.collectError(
      'eth',
      store.tokensToPurchase,
      store.mintForWallet ? 'different-wallet' : 'custodial-wallet',
      transformError(error)?.error
    );
  },
});

const purchaseTokens = async () => {
  telemetry.paymentAttempt('eth', store.tokensToPurchase, 'same-wallet');

  const provider = window.ManifoldEthereumProvider;
  if (!provider.chainIsCorrect()) {
    try {
      await provider.switchToCorrectChain();
    } catch (error) {
      // Network doesn't exist in user's wallet, so add it.
      // TODO: Add network should be a function in the provider
      const { code } = error as { code: number };

      // 4902 is the error code for the requested network not being available in the wallet
      if (code === 4902) {
        const chainConfig = NETWORK_CONFIGS[store.networkId];
        // @ts-ignore
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: `0x${store.networkId.toString(16)}`,
              rpcUrls: chainConfig.rpcUrls,
              chainName: chainConfig.chainName,
              nativeCurrency: chainConfig.nativeCurrency,
              blockExplorerUrls: chainConfig.blockExplorerUrls,
            },
          ],
        });
      }
    }
    await _waitForChainIsCorrect();
  }

  if (store.hasSecondary) {
    collect({ amount: store.tokensToPurchase });
  } else {
    mint({ amount: store.tokensToPurchase });
  }
};

const _waitForChainIsCorrect = () => {
  const poll = (resolve: any) => {
    if (window.ManifoldEthereumProvider.chainIsCorrect()) {
      resolve();
    } else {
      setTimeout((_) => poll(resolve), 50);
    }
  };

  return new Promise(poll);
};

const transformedPurchasingError = computed(() => {
  if (isMintingError.value || mintingError.value) {
    if (store.sigMintError) {
      return store.sigMintErrorMessage;
    }
    return transformError(mintingError.value)?.error;
  }
  if (isCollectingError.value || collectingError.value) {
    return transformError(collectingError.value)?.error;
  }
  return null;
});

const wrongNetworkText = computed(() => {
  if (!store.networkId) {
    return null;
  }
  const networkName = Network.getDisplayNameForNetworkId(store.networkId, true);
  return `Please switch to the ${networkName} network to continue.`;
});

const mintButtonLabel = computed(() => {
  if (store.isFreeClaim) {
    return 'Contribute Now';
  } else {
    return 'Contribute Now';
  }
});

onMounted(() => {
  // HACK: This is a workaround for the fact that the connect widget doesn't render when the modal appears
  setTimeout(() => {
    showConnectWidget.value = true;
  }, 0);
});

return (_ctx: any,_cache: any) => {
  return (purchaseSucceded.value)
    ? (_openBlock(), _createBlock(CheckoutSuccessPage, _mergeProps({
        key: 0,
        "tx-hash": _unref(tx)?.hash || _unref(collectTx)?.hash,
        "payment-method": 'eth',
        "hide-create-your-own": true
      }, _ctx.$attrs), null, 16, ["tx-hash"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(store).signatureSchema === _unref(SignatureSchema).NONE)
          ? (_openBlock(), _createBlock(PurchaseInputForPledge, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(CheckoutItemsForPledge),
        _createVNode(SpecialNetworkBanner, { class: "checkout-network" }),
        _createElementVNode("div", _hoisted_2, [
          (_unref(store).isConnected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(_unref(store).ensOrFormattedWalletAddress), 1)
                  ]),
                  (showConnectWidget.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "checkout-disconnect",
                        "data-widget": "m-connect",
                        "data-grant-type": "signature",
                        "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
                        "data-app-name": "Manifold Claims",
                        "data-delay-auth": "always",
                        "data-wallet-connect-project-id": "ca03bf2709bfa142a2d9adb0d6e99e7f",
                        "data-network": _unref(store).networkId,
                        "data-fallback-provider": _unref(store).fallbackProvider ? _unref(store).fallbackProvider : undefined,
                        "data-enable-network-switching": true,
                        "data-browser-provider-ignore-disconnect": true,
                        "data-multi": "true",
                        "data-message": "Please sign this message to confirm your wallet address",
                        "data-always-open": true
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                (_unref(store).eligibleVaultWallets && _unref(store).walletAddress)
                  ? (_openBlock(), _createBlock(DelegationPicker, {
                      key: 0,
                      class: "checkout-delegation-picker",
                      selectedWallet: _unref(store).mintForWallet ?? _unref(store).walletAddress,
                      delegatedWallet: _unref(store).walletAddress,
                      vaultWallets: _unref(store).eligibleVaultWallets,
                      onWalletSelect: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).setMintForWallet($event)))
                    }, null, 8, ["selectedWallet", "delegatedWallet", "vaultWallets"]))
                  : _createCommentVNode("", true),
                (
            !_unref(store).isChainCorrect ||
            !_unref(store).hasTokensToPurchase ||
            _unref(store).tokensToPurchase > _unref(store).claimableQuantity ||
            !_unref(store).hasEnoughEth ||
            _unref(isMintingError)
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (!_unref(store).isChainCorrect)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(wrongNetworkText.value), 1))
                        : (_unref(isMintingError))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(transformedPurchasingError.value), 1))
                          : (!_unref(store).hasTokensToPurchase)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                (_unref(store).showBadDelegationsWarning)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                      _createTextVNode("No claimable items. A potentially misconfigured delegation was detected for an address eligible for this claim. "),
                                      _hoisted_12
                                    ]))
                                  : (_unref(store).tokensMintedByWallet === 0 || _unref(store).tokensMintedByWallet === null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                        _createTextVNode("Your address "),
                                        _createElementVNode("a", {
                                          href: `${
                  _unref(NETWORK_CONFIGS)[_unref(store).networkId]?.blockExplorerUrls?.[0] || 'https://etherscan.io'
                }/address/${_unref(store).walletAddress}`,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          class: "checkout-error-message"
                                        }, _toDisplayString(_unref(abbreviateAddress)(_unref(store).walletAddress || '')), 9, _hoisted_14),
                                        _createTextVNode(" isn't on the access list for this drop. Try another address or contact the creator to confirm.")
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_15, "You've claimed all your items."))
                              ]))
                            : (_unref(store).tokensToPurchase > _unref(store).claimableQuantity && !_unref(store).hasSecondary)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "You can't claim more than " + _toDisplayString(`${_unref(store).maxNumberToPurchase} ${_unref(pluralize)(_unref(store).maxNumberToPurchase, 'item')}`), 1))
                              : (!_unref(store).hasEnoughEth)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "You don't have enough funds. " + _toDisplayString(_unref(store).isCrossmintVerified && !_unref(store).hasSecondary ? 'Pay with card instead.' : ''), 1))
                                : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  (_unref(tx)?.hash || _unref(collectTx)?.hash)
                    ? (_openBlock(), _createBlock(TransactionDetails, {
                        key: 0,
                        "network-id": _unref(store).networkId || 1,
                        "transaction-hash": _unref(tx)?.hash || _unref(collectTx)?.hash || ''
                      }, null, 8, ["network-id", "transaction-hash"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  id: "restricted-token",
                  class: "manifold-scheme-dark",
                  "data-widget": "m-restricted-token",
                  "data-network": _unref(store).networkId,
                  "data-address": _unref(store).creatorContractAddress
                }, null, 8, _hoisted_19),
                _hoisted_20,
                (_unref(store).hasEnoughEth || _unref(store).hasTokensToPurchase)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "campaign-buy-button",
                      type: "button",
                      disabled: 
            !_unref(store).hasEnoughEth ||
            _unref(isMinting) ||
            _unref(isCollectingLoading) ||
            !_unref(store).isChainCorrect ||
            (!_unref(store).hasSecondary &&
              (_unref(store).isSoldOut ||
                _unref(store).status === 'ended' ||
                _unref(store).tokensToPurchase > _unref(store).claimableQuantity ||
                (!_unref(store).hasEnoughEth && !_unref(store).isCrossmintVerified) ||
                _unref(store).sigMintError)) ||
            !_unref(store).tokensToPurchase ||
            _unref(store).tokensToPurchase < 1
          ,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (!_unref(store).hasEnoughEth ? _ctx.goToPayWithCard() : purchaseTokens()))
                    }, [
                      (!_unref(store).isChainCorrect)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Wrong Network"))
                        : (_unref(store).isSoldOut && !_unref(store).hasSecondary)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Sold Out"))
                          : (_unref(store).status === 'ended' && !_unref(store).hasSecondary)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Sale Ended"))
                            : (_unref(isMinting) || _unref(isCollectingLoading))
                              ? (_openBlock(), _createBlock(Spinner, {
                                  key: 3,
                                  dark: ""
                                }))
                              : (!_unref(store).hasEnoughEth && _unref(store).isCrossmintVerified && !_unref(store).hasSecondary)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Pay with Card"))
                                : (purchaseError.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(purchaseError.value), 1))
                                  : (_unref(store).hasSecondary)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Buy from secondary"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(mintButtonLabel.value), 1))
                    ], 8, _hoisted_21))
                  : (_unref(store).isCrossmintVerified && !_unref(store).hasSecondary)
                    ? (_openBlock(), _createBlock(PayWithCardButton, {
                        key: 3,
                        class: "checkout-payment-method-button",
                        type: "button",
                        onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPayWithCard()))
                      }))
                    : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (showConnectWidget.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "checkout-connect",
                      "data-widget": "m-connect",
                      "data-grant-type": "signature",
                      "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
                      "data-app-name": "Manifold Claims",
                      "data-delay-auth": "always",
                      "data-wallet-connect-project-id": "ca03bf2709bfa142a2d9adb0d6e99e7f",
                      "data-network": _unref(store).networkId,
                      "data-fallback-provider": _unref(store).fallbackProvider ? _unref(store).fallbackProvider : undefined,
                      "data-enable-network-switching": true,
                      "data-browser-provider-ignore-disconnect": true,
                      "data-multi": "true",
                      "data-message": "Please sign this message to confirm your wallet address",
                      "data-always-open": true
                    }, null, 8, _hoisted_30))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]))
}
}

})